
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import router from "@/router";
import { getTranslations, treatLocale } from "@/i18n.service.handler";
import i18n from "@/i18n";



export default class profile extends Vue {
  language = "";

  i18nTranslations = getTranslations;
  treatLocale = treatLocale;

  get user() {
    return store?.state?.authModule?.user;
  }
  get connectedUser() {
    const user = store.getters["authModule/getUserConnected"];
    return {
      code: user.resourceUid,
      isManager: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_MANAGER"),
      isCDV: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_CDV"),
      isSecretary: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_SECRETARY"),
      isAssistant: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_ASSISTANT"),
      isAgent: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_AGENT"),
      isSales: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_SALES"),
      isPrepateur: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_PREPATEUR"),
      isMetteurEnMain: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_METTEUR"),
      isAuditor: user.authorities?.find((el: { authority: string }) => el.authority === "ROLE_AUDITORS")
    };
  }
  get userRole(){
    return  this.connectedUser.isManager ?  i18n.global.t("userPreference.manager")
            : this.connectedUser.isCDV ?  i18n.global.t("userPreference.salesManager")
            : this.connectedUser.isSecretary ?  i18n.global.t("userPreference.secretary") 
            : this.connectedUser.isAssistant ?  i18n.global.t("userPreference.assistant")
            : this.connectedUser.isAgent ?  i18n.global.t("userPreference.agent")
            : this.connectedUser.isSales ?   i18n.global.t("userPreference.salesperson")
            : this.connectedUser.isPrepateur ?  i18n.global.t("userPreference.preparer")
            : this.connectedUser.isAuditor ?  i18n.global.t("userPreference.auditor")
            : ""
  }
get initials() {
  const firstInitial = this.user?.firstName?.trim()?.charAt(0) || '';
  const lastInitial = this.user?.lastName?.trim()?.charAt(0) || '';
  const initials = `${firstInitial}${lastInitial}`.toUpperCase();

  return initials || '--'; 
}
  get languageOptions() {
    return store.getters["authModule/getUserConnected"].preferredLanguages
  }

  UserPreference() {
    store.dispatch("userModule/setMode", "edit");
    router.push("/profile");
  }
}
